import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var FigureLogo = function FigureLogo(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#190050' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '9.6rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Figure Logo' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 96 20",
    fill: "none",
    isInformative: true
  }, rest), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.386597H11.5612V4.20131H0V0.386597ZM0 19.4937V8.03137H11.5612V11.8461H3.84764V19.4937H0Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2002 0.384033H17.3379V19.4939H21.2002V0.384033Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3367 8.0109V11.8256H37.7277V12.6249C37.7277 14.5686 36.1276 16.149 34.1596 16.149C32.1917 16.149 30.5916 14.5686 30.5916 12.6249V7.35695C30.5916 5.41326 32.1917 3.83288 34.1596 3.83288C34.8769 3.83288 35.5574 4.0327 36.1644 4.43233C36.3299 4.54133 36.4954 4.66848 36.6425 4.81381L36.7713 4.9228L39.4565 2.16167L39.3278 2.05268C39.0703 1.79837 38.776 1.56222 38.4817 1.3624C38.4266 1.32607 38.3898 1.28974 38.3346 1.27157H38.3162C38.2794 1.23524 38.2242 1.21708 38.1875 1.18074C36.9736 0.399637 35.5942 0 34.1596 0C30.0583 0 26.7109 3.28792 26.7109 7.35695V12.6431C26.7109 16.6939 30.0399 20 34.1596 20C38.261 20 41.6083 16.7121 41.6083 12.6431V8.0109H35.3367Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2343 0.384033V12.6274V12.7909C56.2343 14.6256 54.7262 16.1152 52.8686 16.1152C51.0111 16.1152 49.5029 14.6256 49.5029 12.7909V12.6274V0.384033H45.6406V12.6274V12.7909C45.6406 16.7328 48.8776 19.9299 52.8686 19.9299C56.8045 19.9299 60.0047 16.8236 60.0966 12.9544V12.7909V12.6274V0.384033H56.2343Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3125 19.4758H79.561L76.0665 12.1733C78.0161 11.0834 79.3219 9.03072 79.3219 6.6874C79.3219 3.21782 76.4528 0.384033 72.9399 0.384033H72.7744H69.4822H67.8454H65.6016V19.4939H69.4639V12.9726H72.1675L75.3125 19.4758ZM69.4822 4.19875H72.7744H72.9399C74.3193 4.19875 75.4596 5.30683 75.4596 6.6874C75.4596 8.04979 74.3377 9.17604 72.9399 9.17604H72.7744H69.4822V4.19875Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0001 4.21691V0.384033H84.4395V19.4939H96.0001V15.6611H88.3052V11.8463H96.0001V8.03163H88.3052V4.21691H96.0001Z",
    fill: color
  }));
};

export default FigureLogo;